import {useState} from 'react'
import {ListLoading} from '../loading/ListLoading'
import {InvoiceLogModalHeader} from './InvoiceLogModalHeader'
import UsageByPeriodListPage from '../../../usageByPeriodList/UsageByPeriodListPage'

interface IInvoiceInfo {
  invoiceId?: number
  invoiceItemId?: number
  onClose?: () => void
}
const InvoiceLogModal = ({invoiceId, invoiceItemId, onClose}: IInvoiceInfo) => {
  const [isLoading, setIsLoading] = useState(false)

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        <div className='modal-dialog modal-dialog-centered mw-950px'>
          <div className='modal-content'>
            {isLoading ? (
              <ListLoading />
            ) : (
              <>
                <InvoiceLogModalHeader onClose={onClose} />

                <div className='card shadow-sm border-0 rounded-4'>
                  <div className='card-body p-5'>
                    <UsageByPeriodListPage invoiceId={invoiceId} invoiceItemId={invoiceItemId} />
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  )
}

export {InvoiceLogModal}
